export const NEWSLETTER_SUBSCRIBE_URL = 'https://87b2c595.sibforms.com/serve/MUIFAL2CcBFHWePd-x_rbr7gaY0LuNQAvURaaHH35U1zI4DtWeJNwHC3nJcXB9byXS1nhxI3TyOiOiv4izl9wl7Z4Z0QPNythQ5WlLXD2HlfQ4YX25XFpL-3u8wfrQ9amd7lBPKBnjNJAyFMezsQ6c7smnzqQwcj0T5U6WpP6PhKwYxbZBj9riyS_YiTbRiVw1rt6qjDfugxK9MEyg==';

export const NEWSLETTER_ISSUES = [
  {
    id: '1026',
    href: '/resources/newsletter/1026',
    volume: 'Volume 2',
    dateLabel: 'October 2026',
    isoDate: '2026-10-01',
    readTime: '10 min read',
    title: 'Ozempic and Wegovy: Medicare Coverage and Patient Costs in 2027',
    summary: 'Ozempic and Wegovy cost comparisons, plan premiums updates, and new MedHug features.',
    topics: ['Medicare Part D', 'Medication costs', '2027 coverage'],
  },
  {
    id: '0826',
    href: '/resources/newsletter/0826',
    volume: 'Volume 1',
    dateLabel: 'August 2026',
    isoDate: '2026-08-01',
    readTime: '12 min read',
    title: 'Medicare GLP-1 Bridge: what we’ve learned since launch',
    summary: 'Eight practical workflow lessons from clinic, plus three new ways to find medication-access options in MedHug.',
    topics: ['Medicare', 'GLP-1 Bridge', 'Medication access'],
  },
];

export function getNewsletterIssuesNewestFirst(issues = NEWSLETTER_ISSUES) {
  return [...issues].sort((left, right) => right.isoDate.localeCompare(left.isoDate));
}
